var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgP16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4.5,
    width: 26,
    height: 23,
    rx: 4,
    stroke: "#F63C47",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5329 15.6643C12.6702 14.7128 11.3327 16.1155 11.3327 16.1155C11.3327 16.1155 9.99514 14.7128 8.13234 15.6643C5.87614 16.8168 5.71411 21.3299 11.3327 23.3333C16.9513 21.3299 16.7892 16.8168 14.5329 15.6643Z",
    stroke: "#F63C47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 22H20",
    stroke: "#F63C47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP16);
export default __webpack_public_path__ + "static/media/p16.c713538a33f574e6543024cf9850c44a.svg";
export { ForwardRef as ReactComponent };